<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 근골격계 유해요인조사 현황-->
    <write-grid-container class="mt-28px" title="근골격계 유해요인조사 현황" v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div v-if="dataType === 'blank'"></div>
          <date-selector-rang v-else-if="dataType === 'daterang'" v-model="form.subInfo[value]" :is-print="true"/>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector-rang v-if="dataType === 'daterang'" v-model="form.subInfo[value]" />
          <div v-else-if="dataType === 'blank'"></div>
          <ml-input v-else-if="dataType === 'number'" class="w-full" type="number" v-model="form.subInfo[value]" :min-value="0" />
          <ml-input v-else-if="dataType === 'year'" class="w-full" type="number" :defaultValue="header.year + 1" :min-value="1900" :max-value="2100" v-model="form.subInfo[value]" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <file-upload-module title="근골격계유해요인결과서 첨부" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";

export default {
  components: {
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      gridContainerOptions: {
        dataTypes: ["number", "number", "number", "string", "daterang", "year"],
        labels: ["대상 공정수", "증상호소자 수", "근골격계 부담 공정수", "조사기관", "조사기간", "차기실시 년도"],
        values: ["대상공정수", "증상호소자수", "근골격계부담공정수", "조사기관", "조사기간", "차기실시년도"],
      },

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    header: {
      immediate: true,
      deep: true,
      handler(value) {
        const year = Number(value.year)
        this.form.subInfo["차기실시년도"] = year + 1;
      },
    }
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = '';
      return acc;
    }, {})

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
